import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const PagChevronLeft = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.5479 3.54116C16.8944 3.88777 17.0891 4.35781 17.0891 4.84792C17.0891 5.33802 16.8944 5.80806 16.5479 6.15467L10.4614 12.2412L16.5479 18.3276C16.8846 18.6762 17.0709 19.1431 17.0667 19.6277C17.0625 20.1124 16.8681 20.5759 16.5254 20.9186C16.1827 21.2613 15.7191 21.4557 15.2345 21.4599C14.7499 21.4641 14.283 21.2778 13.9344 20.9412L6.54116 13.5479C6.19466 13.2013 6 12.7313 6 12.2412C6 11.7511 6.19466 11.281 6.54116 10.9344L13.9344 3.54116C14.281 3.19466 14.7511 3 15.2412 3C15.7313 3 16.2013 3.19466 16.5479 3.54116Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

PagChevronLeft.displayName = 'PagChevronLeft';
